import { IconLayer } from '@deck.gl/layers/typed';
import { Layer } from '@deck.gl/core/typed';
import { createSVGData } from '../utils/createSVGData';

export const SEARCH_LOCATION_PIN_LAYER_ID = 'search-location-pin-layer';

const ICON_SIZE = 86;
const PIN_SIZE = 43;

const SEARCH_PIN_ICON = {
  width: ICON_SIZE,
  height: ICON_SIZE,
  anchorY: ICON_SIZE,
  url: createSVGData(`
    <svg xmlns="http://www.w3.org/2000/svg" width="86" height="86" viewBox="0 0 44 43" fill="none">
  <g filter="url(#filter0_d_6400_103714)">
    <path d="M21.1459 17.1736C21.2781 17.2492 21.4278 17.2889 21.5801 17.2889C21.7324 17.2889 21.8821 17.2492 22.0143 17.1736C22.2823 17.0194 28.5768 13.3455 28.5768 6.78845C28.5218 4.96987 27.7609 3.24415 26.4554 1.97697C25.1498 0.709784 23.4022 0.000711575 21.5827 5.35274e-07C19.7633 -0.000710505 18.0151 0.706996 16.7086 1.97316C15.402 3.23932 14.6398 4.96444 14.5834 6.78298C14.5834 13.3455 20.8812 17.0139 21.1459 17.1736ZM21.5834 4.15798C22.1025 4.15798 22.6101 4.31193 23.0417 4.60037C23.4734 4.88881 23.8099 5.29878 24.0086 5.77843C24.2072 6.25809 24.2592 6.78589 24.1579 7.29509C24.0566 7.80429 23.8066 8.27202 23.4395 8.63913C23.0724 9.00625 22.6047 9.25625 22.0955 9.35754C21.5863 9.45883 21.0585 9.40684 20.5788 9.20816C20.0992 9.00948 19.6892 8.67303 19.4008 8.24135C19.1123 7.80967 18.9584 7.30215 18.9584 6.78298C18.9584 6.08678 19.2349 5.41911 19.7272 4.92682C20.2195 4.43454 20.8872 4.15798 21.5834 4.15798ZM33.8334 18.158C33.8334 21.5683 27.5213 23.408 21.5834 23.408C15.6454 23.408 9.33337 21.5683 9.33337 18.158C9.33337 16.5622 10.7793 15.1491 13.4054 14.18C13.6208 14.1089 13.8553 14.1241 14.0597 14.2226C14.264 14.321 14.4221 14.4949 14.5007 14.7077C14.5793 14.9204 14.5722 15.1554 14.4809 15.363C14.3896 15.5707 14.2212 15.7347 14.0113 15.8206C12.2056 16.4889 11.0834 17.3836 11.0834 18.158C11.0834 19.6192 15.0777 21.658 21.5834 21.658C28.089 21.658 32.0834 19.6192 32.0834 18.158C32.0834 17.3836 30.9612 16.4889 29.1554 15.8217C28.9455 15.7358 28.7772 15.5717 28.6859 15.3641C28.5946 15.1565 28.5875 14.9215 28.6661 14.7088C28.7446 14.496 28.9028 14.3221 29.1071 14.2237C29.3114 14.1252 29.546 14.11 29.7613 14.1811C32.3874 15.1491 33.8334 16.5622 33.8334 18.158Z" fill="#42414E"/>
  </g>
  <defs>
    <filter id="filter0_d_6400_103714" x="4.00543e-05" y="0" width="43.1667" height="42.0747" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="9.33333"/>
      <feGaussianBlur stdDeviation="4.66667"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.0745098 0 0 0 0 0.0705882 0 0 0 0 0.129412 0 0 0 0.2 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6400_103714"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6400_103714" result="shape"/>
    </filter>
  </defs>
</svg>
  `),
};

export type SearchLocationPin = {
  coordinates: [number, number];
  name: string;
};

export const createSearchLocationPinLayer = (pin: SearchLocationPin | null | undefined): Layer | null => {
  if (!pin) return null;

  return new IconLayer<SearchLocationPin>({
    id: SEARCH_LOCATION_PIN_LAYER_ID,
    data: [pin],
    getPosition: (locationPin) => locationPin.coordinates,
    getIcon: () => SEARCH_PIN_ICON,
    getSize: PIN_SIZE,
    sizeScale: 1,
    sizeUnits: 'pixels',
    pickable: true,
  });
};
